import { render, staticRenderFns } from "./help_add.vue?vue&type=template&id=0480a13c&scoped=true&"
import script from "./help_add.vue?vue&type=script&lang=js&"
export * from "./help_add.vue?vue&type=script&lang=js&"
import style0 from "./help_add.vue?vue&type=style&index=0&id=0480a13c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0480a13c",
  null
  
)

export default component.exports